import axios from "axios";

import { API_URL } from "../../const";

export const dashboardFetchProposalAPI = (Data: any) => {
  const data = {
    LeadMasterListAdminToken: Data,
  };

  const url = `${API_URL}LeadMasterCount`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const brokerAPI = (Data: any) => {
  const data = {
    LeadMasterCountBrokerToken: Data,
  };
  const url = `${API_URL}LeadMasterCountBroker`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};
export const leadSourceAPI = (Data: any) => {
  const data = {
    LeadMasterListLeadSourceToken: Data,
  };
  const url = `${API_URL}LeadMasterCountLeadSource`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const dashboardDeleteProposalAPI = (Data: any) => {
  const data = {
    DeleteLeadToken: Data,
  };
  const url = `${API_URL}DeleteLeads`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};
// export const dashboardExportProposalAPI = (Data: any) => {
//   // const data = new URLSearchParams();
//    const data = {
//     LeadMasterListLeadSourceToken: Data,
//   };
//   // data.append("LeadMasterListAdminToken", Data);
//   data.append("CreateRequestReportToken", data);

//   // const url = `${API_URL}ExcelExport/dashboardExport.php`;
//   const url = `${API_URL}CreateRequestReport`;
//   return axios.post(url, data, {
//     headers: { "Content-Type": "application/x-www-form-urlencoded" },
//     responseType: "blob",
//   });
// };

export const dashboardExportProposalAPI = (Data: any) => {
  const data = {
    CreateRequestReportToken: Data,
  };
  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};
